<template>
  <div>
    <page-header
      has-return
      :page="page"
      right-side-class="col-md d-flex align-items-end mb-2"
      @onReturn="$router.back"
    />
    <div class="mt-3">
      <board class="mb-3" :details="board" />
      <q-tab :active-tab="activeTab">
        <q-tab-item :tabindex="0" title="Terapias" @click="setCurrentTab(0)">
          <therapies
            v-if="academicYears?.length"
            :academic-years="academicYears"
            :referral="info"
          />
        </q-tab-item>
        <q-tab-item
          lazy
          :tabindex="1"
          title="Evaluaciones"
          @click="setCurrentTab(1)"
        >
          <evaluations :student-id="info?.studentSie" />
        </q-tab-item>
        <q-tab-item lazy :tabindex="2" title="PEI" @click="setCurrentTab(2)">
          <pei-history :student-id="info?.studentSie" />
        </q-tab-item>
      </q-tab>
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import { Therapies, PeiHistory, Evaluations } from './components/record';
import { getAcademicYearWithDocuments } from '@/modules/shared/studentreferral.api';
import { getAppointmentRecord } from '@/modules/appointmentManagement/api.js';

const TABS = Object.freeze({
  Therapies: 0,
  Evaluations: 1,
  PEI: 2,
});

export default {
  components: {
    PageHeader,
    Board,
    QTab,
    QTabItem,
    PeiHistory,
    Evaluations,
    Therapies,
  },
  data: () => ({
    activeTab: TABS.Therapies,
    info: {},
    academicYears: [],
  }),
  computed: {
    page() {
      return {
        icon: 'fas fa-file-alt',
        title: 'Expediente del estudiante',
        routes: [
          'Inicio',
          'Proveedor',
          'Manejo de Citas',
          'Seguimiento',
          'Expediente del estudiante',
        ],
      };
    },
    board() {
      return [
        [
          {
            label: 'Número de Cita:',
            icon: 'fas fa-calendar-exclamation',
            data: this.info?.formatedClientAppointmentId,
          },
          {
            label: 'Disciplina de la Cita:',
            icon: 'fas fa-ballot-check',
            data: this.info?.disciplineType?.name,
          },
          {
            label: 'Estudiante:',
            icon: 'fas fa-address-book',
            data: this.info?.studentFullName,
          },
          {
            label: 'SIE:',
            icon: 'fas fa-file-alt',
            data: this.info?.studentSie,
          },
        ],
      ];
    },
    clientAppointmentId() {
      return Number(this.$route.params.clientAppointmentId);
    },
    tabParam() {
      return Number(this.$route.query.tab ?? TABS.Therapies);
    },
  },
  async mounted() {
    await this.initData();
  },
  methods: {
    async initData() {
      await this.getRecordInfo();
      await this.getAcademicYears();
      this.activeTab = this.tabParam;
    },
    async getRecordInfo() {
      const { data } = await getAppointmentRecord(this.clientAppointmentId);
      this.info = data;
    },
    async getAcademicYears() {
      const { data } = await getAcademicYearWithDocuments(this.info.studentSie);
      let { current, academicYears } = data;
      academicYears.forEach((x) => (x.selected = false));
      current = academicYears.find((x) => x.id === current.id) ?? current;
      current.selected = true;
      this.academicYears = [...new Set([current, ...academicYears])];
    },
    setCurrentTab(tab) {
      const sameRoute = this.tabParam === tab;
      if (sameRoute) return;

      this.activeTab = tab;
      const path = tab ? { query: { tab } } : { name: this.$route.name };
      this.$router.replace(path);
    },
  },
};
</script>
